export const SANCTION_STATUS = {
  AWAITING_REVIEW: "AwaitingReview"
};
